import React, { FC, useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import PollEntity from '../../../store/polls-store/poll-entity';
import PollFullScreenContainer from './poll-full-screen-container';
import ResponseEntity from '../../../store/polls-store/response-entity';
import { getErrorBoundaryStore } from '../../../store/error-boundary-store/error-boundary-store-instanse';
import { IErrorObject } from '../../../utils/services/error-parsing-service';
import './poll-full-screen.scss';
import { openFullscreen } from '../../../utils/helpers/polls-helper';
import classNames from 'classnames';

interface IProps {
  poll: PollEntity | null;
  getPollChoisesList: (pollId: string) => Promise<ResponseEntity[] | void>;
  closeFullScreenMode: () => void;
  isFullScreenModeSafari: boolean;
}

const PollFullScreen: FC<IProps> = ({ poll, getPollChoisesList, closeFullScreenMode, isFullScreenModeSafari }) => {
  const ref = useRef<HTMLDivElement>(null);
  const errorBoundary = getErrorBoundaryStore();

  useEffect(() => {
    const element = ref.current;

    if (element) {
      const requestFullScreen = openFullscreen(element) || Promise.resolve();
      requestFullScreen
        .catch((error: IErrorObject) => errorBoundary.setErrorMessage(error));
    }
  }, []);

  return (
    <div className={classNames('poll-full-screen-wrapper', { 'is-safari': isFullScreenModeSafari })} ref={ref}>
      {poll && <PollFullScreenContainer poll={poll} getPollChoisesList={getPollChoisesList} closeFullScreenMode={closeFullScreenMode}/>}
    </div>
  );
};

export default observer(PollFullScreen);
